IREP.QSTRegister = (function () {
    "use strict";

    var vm = {};
    var init = function () {        
        $("#submitQSTRegistration").click(function () {
            var IsValid = false;
            if ((ddlCountry.SelectedValue != "") && (txtFirst.Text != "") && (txtLast.Text != "") && (ddlCompany.SelectedValue != "") && (ddlStore.SelectedValue != "") && (chk18.Checked != false) && (chkTerms.Checked != false) && (txtPassword.Text == txtConfirm.Text) && (crqTxtPassword.IsValid)) {
                IsValid = true;
            }
            if (IsValid) {
                SaveRegistration();
            } else {
                if (ddlCountry.SelectedValue == "") {
                    spanddlCountryError.Attributes.Remove("class");
                    spanddlCountryError.Attributes.Add("class", "errortext show");
                } else {
                    spanddlCountryError.Attributes.Remove("class");
                    spanddlCountryError.Attributes.Add("class", "errortext hide");
                }
                if (txtFirst.Text == "") {
                    reqTxtFirst.IsValid = false;
                }
                if (txtLast.Text == "") {
                    reqTxtLast.IsValid = false;
                }
                if (ddlCompany.SelectedValue == "") {
                    spanddlCompanyError.Attributes.Remove("class");
                    spanddlCompanyError.Attributes.Add("class", "errortext show");
                } else {
                    spanddlCompanyError.Attributes.Remove("class");
                    spanddlCompanyError.Attributes.Add("class", "errortext hide");
                }
                if (ddlStore.SelectedValue == "") {
                    spanddlStoreError.Attributes.Remove("class");
                    spanddlStoreError.Attributes.Add("class", "errortext show");
                } else {
                    spanddlStoreError.Attributes.Remove("class");
                    spanddlStoreError.Attributes.Add("class", "errortext hide");
                }
                if (txtPassword.Text != txtConfirm.Text) {
                    reqTxtConfirm.IsValid = false;
                }
                if (chk18.Checked != true) {
                    chk18Error.Attributes.Remove("class");
                    chk18Error.Attributes.Add("class", "errortext show");
                } else {
                    chk18Error.Attributes.Remove("class");
                    chk18Error.Attributes.Add("class", "errortext hide");
                }
                if (chkTerms.Checked != true) {
                    chkTermsError.Attributes.Remove("class");
                    chkTermsError.Attributes.Add("class", "errortext show");
                } else {
                    chkTermsError.Attributes.Remove("class");
                    chkTermsError.Attributes.Add("class", "errortext hide");
                }
            }
        });
    }    

    return {
        init: init
    };
})();